import styled, { css } from 'styled-components';
import { useThemeMode } from '../../theme';

const StyledHeader = styled.header<{ $light: boolean }>(
  ({ $light, theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 1.25rem;
    padding: 0.75rem 1.25rem calc(0.75rem - ${$light ? '2px' : '0px'}) 1.25rem;
    background: ${theme.paper.default};
    border-bottom: ${$light ? '3px' : '1px'} solid ${theme.border.default};
  `
);

const IconLink = styled.a`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.text.default};
  line-height: 0;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }
`;

const ThemeToggle = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-left: auto;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.border.default};
  background: ${({ theme }) => theme.paper.default};
  color: ${({ theme }) => theme.text.default};
  cursor: pointer;
  line-height: 0;
  transition: background 0.2s;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;

  &:hover {
    opacity: 0.7;
  }
`;

function CoffeeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18 8h1a4 4 0 0 1 0 8h-1" />
      <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z" />
      <line x1="6" y1="1" x2="6" y2="4" />
      <line x1="10" y1="1" x2="10" y2="4" />
      <line x1="14" y1="1" x2="14" y2="4" />
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </svg>
  );
}

function SunIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="5" />
      <line x1="12" y1="1" x2="12" y2="3" />
      <line x1="12" y1="21" x2="12" y2="23" />
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
      <line x1="1" y1="12" x2="3" y2="12" />
      <line x1="21" y1="12" x2="23" y2="12" />
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  );
}

export function Header() {
  const { mode, toggleTheme } = useThemeMode();

  return (
    <StyledHeader $light={mode === 'light'}>
      <IconLink
        href="https://buymeacoffee.com/lovemedoku"
        target="_blank"
        rel="noopener noreferrer"
        title="Buy me a coffee"
      >
        <CoffeeIcon />
      </IconLink>
      <IconLink
        href="https://www.instagram.com/lovemedoku"
        target="_blank"
        rel="noopener noreferrer"
        title="Instagram"
      >
        <InstagramIcon />
      </IconLink>
      <ThemeToggle
        onClick={toggleTheme}
        aria-label="Toggle theme"
        title="Toggle theme"
      >
        {mode === 'dark' ? <SunIcon /> : <MoonIcon />}
      </ThemeToggle>
    </StyledHeader>
  );
}
